module.exports = __webpack_public_path__ + "static/media/img4.b653a7a2.jpg";